import { useTimezoneParam } from '@features/date-time';
import { useFilter } from '@features/table-filter';

import { useGetTokenBuysQuery } from '../api';
import type { ITokenBuyFilter } from '../model/types';

interface IProps {
  disableUrlFilter?: boolean;
  refreshInterval?: string;
}

export const useTokenBuys = ({ disableUrlFilter, refreshInterval }: IProps = {}) => {
  const filter = useFilter<ITokenBuyFilter>({ disableUrlFilter });
  const { currentFilter, updateFilter } = filter;

  useTimezoneParam({ currentFilter, updateFilter });

  const {
    data: tokenBuys,
    isLoading,
    isError,
    error,
    isFetching,
    isSuccess,
    refetch,
  } = useGetTokenBuysQuery(currentFilter.toString(), {
    pollingInterval:
      !refreshInterval || refreshInterval === 'off' ? undefined : parseInt(refreshInterval),
  });

  return {
    tokenBuys,
    isError,
    error,
    isLoading,
    isFetching,
    isSuccess,
    refetch,

    filter,
  };
};
